const quickLinks = [
  { label: "Home", href: "#home" },
  { label: "About Carol", href: "#about" },
  { label: "Our Paths", href: "#paths" },
  { label: "Benefits", href: "#benefits" },
  { label: "Your Journey", href: "#journey" },
];

import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  const { ref, visible } = useScrollReveal();

  return (
    <footer className="bg-olive-800 text-olive-100 pt-14 pb-6">
      <div ref={ref} className={`mx-auto px-4 md:px-6 max-w-6xl transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-7'}`}>
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          <div>
            <img
              alt="Wellness & Freedom Logo"
              className="h-12 w-auto mb-4 brightness-0 invert"
              src="https://trzebeky.gensparkspace.com/images/logo.png"
            />
            <p className="text-olive-300 text-sm leading-relaxed">
              Helping busy families create more freedom — naturally. Through
              eco-friendly living and simple income systems, you can have both
              health and financial peace.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              Quick Links
            </h4>
            <ul className="space-y-2 text-sm">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(link.href);
                    }}
                    className="text-olive-300 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">
              Get in Touch
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3 text-olive-300">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="fas fa-envelope text-xs"></i>
                </span>
                <a
                  href="mailto:carol@wellnessandfreedom.net"
                  className="hover:text-white transition-colors"
                >
                  carol@wellnessandfreedom.net
                </a>
              </li>
              <li className="flex items-center gap-3 text-olive-300">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="fas fa-calendar-alt text-xs"></i>
                </span>
                <a
                  href="https://calendly.com/carol-berry305"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Schedule a Call
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-olive-700/50 pt-6 text-center text-xs text-olive-400">
          © 2024 Wellness & Freedom. All rights reserved. | Created with 🌿 by
          Carol Berry
        </div>
      </div>
    </footer>
  );
}